import { EmptyTableBody, Svg } from '@innovyze/stylovyze/lib/components';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts';
import React from 'react';
import BellIcon from './Bell.svg';
export const NoNotification = () => {
    const { t } = useGlobalization();
    return (React.createElement("div", { style: { marginTop: '64px' } },
        React.createElement(EmptyTableBody, { icon: React.createElement(Svg, { svg: BellIcon }), title: t('You currently have no notifications'), subtitle: "" })));
};
